import React, { FC, useContext, useEffect } from "react";
import "./StaticPriceComp.css";
import { countZero, getElementMaximumHeight } from "../../utils/utils";
import CardContext from "../../utils/store/card-context";

interface StaticPriceCompSchema {
  content: any;
  addToCart?: (e: any) => void;
  variant: string;
}

const StaticPriceComp: FC<StaticPriceCompSchema> = ({
  content,
  addToCart,
  variant,
}) => {
  const cardContext = useContext(CardContext);
  const findHeight = () => {
    getElementMaximumHeight(
      `linetable-staticPrice-priceSection`,
      cardContext.listLength
    );
  };

  useEffect(() => {
    setTimeout(() => {
      findHeight();
    }, 200);
    window.addEventListener("resize", findHeight);
  }, [content]);

  const addButtonHandler = () => {
    if (typeof addToCart == "function") addToCart(content);
  };
  
  return (
    <div
      className={`linetable-staticPrice-priceWrapper ${
        variant === "productDetails" &&
        "linetable-staticPrice-productDetails-priceWrapper"
      }`}
    >
      <div id={`linetable-staticPrice-priceSection${cardContext?.indexKey}`}>
        <div className="linetable-staticPrice-priceSection">
          {content?.isEnableDiscountPrice && (
            <span className="linetable-staticPrice-discountPriceSection">
              <span className="linetable-staticPrice-discountedPrice">
                {content?.discountPriceValue}
              </span>
              {content?.priceDuration}
            </span>
          )}
          <span>
            <span
              className={`linetable-staticPrice-basePrice ${
                content?.isEnableDiscountPrice
                  ? "linetable-staticPrice-priceStrikeout"
                  : "linetable-staticPrice-noDiscountPrice"
              }`}
            >
              {countZero(content?.priceValue)}
            </span>
            {!content?.isEnableDiscountPrice && <>{content?.priceDuration}</>}
          </span>
        </div>
        <div className="linetable-staticPrice-contractDescription">
          {content?.contractDescription}
        </div>
      </div>
      <div>
        <button
          className={`linetable-staticPrice-addToCart ${
            variant === "productDetails" &&
            "linetable-staticPrice-productDetails-addToCart"
          }`}
          onClick={addButtonHandler}
        >
          {content?.addButton}
        </button>
      </div>
    </div>
  );
};

export default StaticPriceComp;
